define('module/ugc',[
    'jquery',
    'underscore',
    'cnf'
], function($, _, Cnf) {
    'use strict';

    /**
     * handle upload file to 3Q Server
     * 
     * @see https://github.com/3QSDN/fileupload
     * @jira FDZ-491
     * @date 2021-07-05
     * @author sh@sopg.de
     */
    
    return function()
    {
        this.cnf = {
            selector: {
                trigger: '[data-trigger="ugc-upload-video"]',
                file: 'input[type="file"]',
                submit: 'button.button-submit',
                msg: '.msg',
                progress: 'progress'
            },
            attr:{
                error:'data-error'
            },
        };

        /**
         * main entry
         */
        this.init = function()
        {
            this.oUgc = {};

            this.initElement();
            this.initEvent();
        }

        /**
         * init element
         */
        this.initElement = function()
        {
            this.$el = Cnf.$app.find(this.cnf.selector.trigger);

            if(this.$el.length > 0) {
                _.each(this.$el, function(item, index) {
                    this.oUgc[index] = {
                        index: index,
                        busy: false,
                        $el : this.$el.eq(index),
                        $file : this.$el.eq(index).find(this.cnf.selector.file),
                        $submit : this.$el.eq(index).find(this.cnf.selector.submit),
                        $hidden: this.$el.eq(index).find('input[type="hidden"]'),
                        $msg: this.$el.eq(index).find(this.cnf.selector.msg),
                        $progress: this.$el.eq(index).find(this.cnf.selector.progress)
                    }
                }, this);
            }
        }

        /**
         * init event
         */
        this.initEvent = function()
        {
            //bind listener on click submit
            _.each(this.oUgc, function(item) {
                item.$submit.on('click', _.bind(this.triggerUpload, this, item.index));
            }, this);
        }

        /**
         * 
         * @returns 
         */
        this.triggerUpload = function(index)
        {
            if(false !== this.oUgc[index].busy) {
                return;
            }
            this.oUgc[index].busy = true;
            this.oUgc[index].$submit.attr('disabled', 'disabled')
                .addClass('pending');

            var oFile = this.oUgc[index].$file.get(0).files[0];

            //check against file
            if(typeof oFile === 'undefined') {
                this.oUgc[index].$msg.html('<div ' + this.cnf.attr.error + '="true">Fehler: keine Datei ausgewählt.</div>');
                this.oUgc[index].busy = false;
                this.oUgc[index].$submit.removeAttr('disabled')
                    .removeClass('pending');
                return;
            }

            //fetch form data
            var oData = {};
            _.each(this.oUgc[index].$hidden, function(item){
                oData[item.name] = item.value;
            }, oData);

            //append filename
            oData.filename = oFile.name;
            oData.fileformat = oFile.name.substr(oFile.name.lastIndexOf('.') + 1);
            
            //request 3Q location, start upload on success
            $.ajax({
                url:window.cnf.host + window.cnf.api,
                dataType:'json',
                method:'post',
                data: oData,
                complete:_.bind(function(index,xhr) {
                    try {
                        
                        //renew token if given
                        if(typeof xhr.responseJSON.token !== 'undefined') {
                            _.each(xhr.responseJSON.token, _.bind(function(token,name) {
                                this.oUgc[index].$hidden.filter('[name="' + name + '"]').attr('value', token);
                            },this));
                        }

                        //trigger upload on success
                        if(
                            (xhr.status === 200)
                            && (typeof xhr.responseJSON.location === 'string')
                        ) {
                            this.upload3Q(index, xhr.responseJSON.location, oFile);
                        } else {

                            this.oUgc[index].busy = false;
                            this.oUgc[index].$submit.removeAttr('disabled')
                                .removeClass('pending');

                            //print error
                            if(typeof xhr.responseJSON.error !== 'undefined') {
                                _.each(xhr.responseJSON.error, _.bind(function(msg){
                                    var oArg={html:msg};
                                    oArg[this.cnf.attr.error]='true';
                                    $('<div/>', oArg).appendTo(this.oUgc[index].$msg);
                                },this));
                            } else {
                                this.oUgc[index].$msg.html('<div ' + this.cnf.attr.error + '="true">Es ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut (code 88ik3).</div>');
                            }

                        }

                    } catch(e) {
                        this.oUgc[index].busy = false;
                        this.oUgc[index].$submit.removeAttr('disabled')
                            .removeClass('pending');
                        this.oUgc[index].$msg.html('<div ' + this.cnf.attr.error + '="true">Es ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut (code uiuj8).</div>');
                    }
                }, this, index)
            });
        }

        /**
         * upload given file on 3Q server
         * 
         * @provide update metadata on success
         * 
         * @param {int} index 
         * @param {string} uri 
         * @param {object} file 
         */
        this.upload3Q = function(index, uri, file)
        {
            var xhr = new XMLHttpRequest();

            // upload progress
            var $progress = this.oUgc[index].$progress,
                $span = this.oUgc[index].$progress.parent().find('span');
            xhr.upload.onprogress = function (e) {
                if (e.lengthComputable) {
                    $progress.attr({
                        value: e.loaded,
                        max: e.total,
                    });
                    $span.html(((e.loaded / e.total) *100).toFixed(0) + '% (' + (e.loaded / 1024 / 1024).toFixed(0) + 'MB/' + (e.total / 1024 / 1024).toFixed(0) + 'MB)');
                }
            }


            // upload finished, get FileId from response
            xhr.onload = _.partial(function (_this, e) {
                
                _this.oUgc[index].busy = false;
                _this.oUgc[index].$submit.removeAttr('disabled')
                    .removeClass('pending');

                if (this.status === 201) {
                    var response = JSON.parse(this.response);
                    
                    //fetch form data
                    var oData = {};
                    _.each(_this.oUgc[index].$hidden, function(item){
                        oData[item.name] = item.value;
                    }, oData);
                    //metadata_action is our current action
                    oData.action = oData.metadata_action;

                    //append fileid
                    oData.fileid = response.FileId;
                    
                    //request to 3Q server to update metadata i.e. set hash
                    $.ajax({
                        url:window.cnf.host + window.cnf.api,
                        dataType:'json',
                        method:'post',
                        data: oData,
                        complete:_.bind(function(index,xhr) {
                            try {

                                this.oUgc[index].busy = false;
                                this.oUgc[index].$submit.removeAttr('disabled')
                                    .removeClass('pending');
                                
                                //renew token if given
                                if(typeof xhr.responseJSON.token !== 'undefined') {
                                    _.each(xhr.responseJSON.token, _.bind(function(token,name) {
                                        this.oUgc[index].$hidden.filter('[name="' + name + '"]').attr('value', token);
                                    },this));
                                }

                                //print error
                                if(typeof xhr.responseJSON.error !== 'undefined') {
                                    _.each(xhr.responseJSON.error, _.bind(function(msg){
                                        var oArg={html:msg};
                                        oArg[this.cnf.attr.error]='true';
                                        $('<div/>', oArg).appendTo(this.oUgc[index].$msg);
                                    },this));
                                }

                                //display success
                                _.each(xhr.responseJSON.success, _.bind(function(msg){
                                    var oArg={html:msg};
                                    oArg[this.cnf.attr.error]='false';
                                    $('<div/>', oArg).appendTo(this.oUgc[index].$msg);
                                },this));

                                //reset form
                                if(xhr.status === 200) {
                                    this.oUgc[index].$file.val("");
                                }

                            } catch(e) {
                                this.oUgc[index].busy = false;
                                this.oUgc[index].$submit.removeAttr('disabled')
                                    .removeClass('pending');
                                this.oUgc[index].$msg.html('<div ' + this.cnf.attr.error + '="true">Es ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut (code oqjhd).</div>');
                            }
                        }, _this, index)
                    });
                } else {
                    _this.oUgc[index].busy = false;
                    _this.oUgc[index].$submit.removeAttr('disabled')
                        .removeClass('pending');
                    _this.oUgc[index].$msg.html('<div ' + _this.cnf.attr.error + '="true">Es ist ein Fehler aufgetreten. Versuchen Sie es zu einem späteren Zeitpunkt erneut (code llka7)</div>');
                }
            }, this);

            // put content in body
            xhr.open("PUT", uri);
            xhr.send(file);
        }

        this.init();
    };
});
